var render, staticRenderFns
import script from "./order_download.vue?vue&type=script&lang=js"
export * from "./order_download.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00a9f5b2')) {
      api.createRecord('00a9f5b2', component.options)
    } else {
      api.reload('00a9f5b2', component.options)
    }
    
  }
}
component.options.__file = "found/views/kms_new/views/backstage_manage/order_download/order_download.vue"
export default component.exports